import { render } from "./reCaptcha.vue?vue&type=template&id=20ebb75b"
import script from "./reCaptcha.vue?vue&type=script&lang=js"
export * from "./reCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__